__turbopack_context__.v({
  "algoliaCard": "EfcRxq_algoliaCard",
  "author": "EfcRxq_author",
  "cAuthorName": "EfcRxq_cAuthorName",
  "categoryOther": "EfcRxq_categoryOther",
  "content": "EfcRxq_content",
  "contentCard": "EfcRxq_contentCard",
  "image": "EfcRxq_image",
  "tagLink": "EfcRxq_tagLink",
  "v-card": "EfcRxq_v-card",
});
